import { Controller } from "@hotwired/stimulus";
import { Modal } from "bootstrap";

class CopyArticleAddressController extends Controller {
  static targets = ["modal", "input", "button"];

  connect() {
    this.modal = new Modal(this.modalTarget);
  }

  copy() {
    navigator.clipboard.writeText(this.inputTarget.value);
    this.buttonTarget.innerText = "Copiado!";
  }

  openAndCopy() {
    this.modal.show();
    this.copy();
  }
}

export default CopyArticleAddressController;
